import { Play } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { MessageAttachment } from "../../features/messages/models/MessageAttachment";
import { MessagesChannel } from "../../features/messages/models/MessagesChannel";
import AttachmentRow from "./AttachmentRow";
import { useOpenAttachment } from "./useOpenAttachment";

interface VideoRowProps {
  attachment: MessageAttachment;
  channel: MessagesChannel;
}

/** A video as a row with Play; Play fetches its URL and plays it in place. */
const VideoRow = ({ attachment, channel }: VideoRowProps) => {
  const { t } = useTranslation();
  const { fetchUrl } = useOpenAttachment(channel);
  const [src, setSrc] = useState<string | null>(null);

  if (src) {
    return (
      <video
        src={src}
        controls
        autoPlay
        playsInline
        className="block w-full max-w-[320px] rounded-lg border border-grey-90 dark:border-primary-20"
        aria-label={attachment.fileName}
      />
    );
  }

  return (
    <AttachmentRow
      attachment={attachment}
      actionLabel={t("messages.attach.play")}
      actionIcon={Play}
      onAction={() => void fetchUrl(attachment.id).then(setSrc)}
    />
  );
};

export default VideoRow;
